<script>
import abbreviate from 'number-abbreviate';
import moment from 'moment';

export default {
    name: 'CpEndorsesProfilesItem',
    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop,
    },
    components: {
        PersonIcon: require('../social-feed/icons').default,
        CpBaseSvgIcon: require('../base-svg-icon').default,
        CpImage: require('../image').default,
        handleImageError: require('../mixins/utils').default,
    },
    props: {
        data: { type: Object, default: () => {} },
    },
    computed: {
        timeAgo() {
            return moment.utc(this.data.created_at).local().fromNow();
        },
    },
};
</script>

<template>
    <div class="social-feed-post-wrapper" style="margin-bottom: 5px">
        <a :href="'/profile/' + data.slug" style="text-decoration: none">
            <div class="social-feed-post-profile-wrapper">
                <div>
                    <span class="profile-img social-feed-default-img">
                        <cp-image
                            :src="`${data.profile_image}`"
                            circular
                            alt="Profile image"
                            @error="handleImageError"
                            :width="$root.isMobile ? '40' : '50'"
                            :height="$root.isMobile ? '40' : '50'"
                        ></cp-image>
                    </span>
                </div>
                <div class="mini-recipient">
                    <div style="display: flex;">
                        <span class="profile-name mini-recipient__title">{{ data.name }}</span>
                    </div>
                    <span class="mini-recipient__subtitle">{{ timeAgo }}</span>
                </div>
            </div>
        </a>
    </div>
</template>

<style scoped>
div.social-feed-post-profile-wrapper {
    display: flex;
    flex-direction: row;
}
div.social-feed-post-profile-wrapper .details-wrapper {
    display: flex;
    flex-direction: column;
    padding-left: 10px;
}

div.social-feed-post-profile-wrapper .profile-name {
    font-size: 1.2em;
    padding: 0px;
}

div.social-feed-post-profile-wrapper .post-time {
    color: #666;
}

img.social-feed-post-img {
    max-width: 100%;
    max-height: 100%;
    min-width: 100%;
}
span.social-feed-default-img {
    display: flex;
    align-items: center;
    justify-content: center;
}
a.social-feed-post-link {
    display: block;
    padding-top: 10px;
    font-size: 1.1em;
}
.social-feed-post-wrapper {
    width: 100%;
    padding: 0.5em !important;
    border: 0px solid #efefef !important;
    margin-bottom: 0em !important;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto;
}
div.social-feed-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.social-feed-post-wrapper > * {
    width: 100%;
}

.mini-recipient__subtitle {
    margin-top: 0px;
}

div.social-feed-box-wrapper.mobile img.social-feed-post-img {
    min-height: 45vh;
    object-fit: cover;
}
.social-feed-default-img {
    background: #ffe3da;
    color: var(--highlight);
}
div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
    padding: 0.7em;
}
div.social-feed-post-img-placeholder {
    min-height: 400px;
    background: rgb(233, 94, 54);
    background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
}
header.social-feed-title-header {
    text-align: center;
    margin: 30px 0px;
}
div.social-feed-post-description {
    padding-top: 10px;
}
video.candidate-video-player {
    width: 100%;
    height: auto;
}
.profile-img.social-feed-default-img svg {
    margin-top: 10px;
}
.profile-img {
    width: 50px;
    height: 50px;
}
.social-feed-sidebar {
    position: fixed;
}

.header-label {
    font-size: 16px;
    font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
    font-weight: 600;
    color: #121212;
}

.mobile-fixed-bottom-sidebar .social-feed-right-sidebar {
    padding: 15px;
    position: relative;
    max-width: 100% !important;
}

.small-desktop-right-sidebar .social-feed-right-sidebar {
    max-width: 12.2vh;
}

.small-desktop-right-sidebar .title-3 hr {
    display: none;
}

.mobile-fixed-bottom-sidebar {
    position: fixed;
    background: white;
    width: 100% !important;
    bottom: 0px;
    left: 0px;
    margin: 0px;
}
</style>
